import { defineStore } from 'pinia'
import { RouteRecordName } from 'vue-router'
// import { RouteLocationNormalized } from 'vue-router'

interface NavigationState {
  referrer: string | null
  popstate: boolean
  // from?: RouteLocationNormalized
  // to?: RouteLocationNormalized
  from?: RouteRecordName | null
  to?: RouteRecordName | null
  trigger?: 'listing' | 'megamenu'
}

const defaultState = (): NavigationState => ({
  referrer: null,
  popstate: false,
  from: null,
  to: null,
  trigger: undefined,
})

export const useNavigationStore = defineStore('navigation', {
  state: defaultState,
})
